import { Box, Typography, useTheme } from "@mui/material";
import { ReactNode } from "react";

interface DropdownTriggerButtonProps {
  icon?: ReactNode;
  label: string;
  onClick: (event: React.MouseEvent<HTMLElement>) => void;
  chevron?: ReactNode;
  sx?: object;
}

export const DropdownTriggerButton = ({
  icon,
  label,
  onClick,
  chevron,
  sx = {},
}: DropdownTriggerButtonProps) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        display: "flex",
        gap: theme.nawy.spacing.xs,
        padding: theme.nawy.spacing.sm,
        alignItems: "center",
        width: "100%",
        height: "100%",
        cursor: "pointer",
        justifyContent: "space-between",
        ":hover": {
          backgroundColor: "#F0F4F8",
        },
        ...sx,
      }}
      onClick={onClick}
    >
      <Box
        sx={{
          display: "flex",
          gap: theme.nawy.spacing.xs,
          alignItems: "center",
        }}
      >
        {icon && icon}
        <Typography
          sx={{
            color: theme.nawy.colors.semantic.text.primary,
            ...theme.nawy.typography.english.variants.body.md.regular,
          }}
        >
          {label}
        </Typography>
      </Box>
      {chevron}
    </Box>
  );
};
